import { FC, useState, useEffect } from 'react';
import cx from 'classnames/bind';
import { motion, AnimatePresence } from 'framer-motion';

import { Layout } from '@/components/Layout';
import { Mode } from '@/components/Mode';
import { PointsInfo } from '@/components/PointsInfo';
import { ButtonLink } from '@/components/ButtonLink';
import { Notification } from '@/components/Notification';
import { ModalCollectOrder } from '@/components/Modal/ModalCollectOrder';
import { ModalPointsReceived } from '@/components/Modal/ModalPointsReceived';
import { Orders } from '@/components/Game/Orders';
import { getNumberPointsPerGame } from '@/utils/getNumberPointsPerGame';
import type { IBox, IBoxes } from '@/types/pack';

import styles from './Step1.module.scss';

interface Step1Props {
  totalPoints: number;
  userToken: string;
  setStep: (value: number) => void;
  setIdPack: (value: number) => void;
  timer: number;
  isNotification: boolean;
  setIsNotification: (value: boolean) => void;
  setPackss: (value: IBoxes[]) => void;
  points: number;
  setPoints: (value: number) => void;
  currentPack?: IBox;
  isViewModal?: boolean;
  currentList: string;
  setCurrentList: (value: string) => void;
  firstPlay: boolean;
}

const cn = cx.bind(styles);

const Step1: FC<Step1Props> = ({
  totalPoints,
  userToken,
  setStep,
  setIdPack,
  timer,
  isNotification,
  setIsNotification,
  setPackss,
  points,
  setPoints,
  currentPack,
  isViewModal,
  currentList,
  setCurrentList,
  firstPlay,
}) => {
  const [modal, setModal] = useState('');

  const [packs, setPacks] = useState<IBoxes[]>(); // TODO:: поправить

  const openModal = () => {
    setModal('collectOrder');
  };

  useEffect(() => {
    fetch(`https://admin.znatok.jti-games.dev.familyagency.ru/api/orders`, {
      headers: {
        UserToken: userToken,
      },
    })
      .then((response) => response.json())
      .then(({ data }) => {
        setPacks(data);
        setPackss(data);
      });
  }, []);

  const firstList = packs?.[0]?.orders;
  const secondList = packs?.[1]?.orders;
  const thirdList = packs?.[2]?.orders;

  const list = [
    ...(firstList || []),
    ...(secondList || []),
    ...(thirdList || []),
  ];

  useEffect(() => {
    const allPoints = list.reduce(
      (acc: number, current) => acc + current.score,
      0,
    );

    setPoints(allPoints);
  }, [packs]);

  const isAllPointsReceived = list?.every(
    ({ achievement }) => achievement !== null,
  );

  const MotionNotification = motion(Notification);

  const numberPointsPerGame = getNumberPointsPerGame(totalPoints);

  return list.length ? (
    <Layout className={cn('container')}>
      {/* Всплывающая плашка с баллами */}
      {isNotification && currentPack?.achievement === null && (
        <AnimatePresence>
          <MotionNotification
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 20, opacity: 0 }}
            transition={{ duration: 1.5, delay: 0, ease: 'backInOut' }}
            onAnimationComplete={() => {
              setIsNotification(false);
            }}
            className={cn('points')}
            points={numberPointsPerGame}
          />
        </AnimatePresence>
      )}
      {/* Модальное окно "Как собрать заказ?" */}
      <ModalCollectOrder
        modal={modal}
        setModal={setModal}
        totalPoints={totalPoints}
        timer={timer}
        setStep={setStep}
      />
      {/* TODO:: Вы получили все доступные баллы */}
      <ModalPointsReceived
        modal={modal}
        setModal={setModal}
        setStep={setStep}
      />
      {list.length && isAllPointsReceived ? <Mode /> : null}
      <PointsInfo
        text="Нажимайте на коробки, чтобы собирать заказы"
        points={list.length && isAllPointsReceived ? undefined : points}
        className={cn(isAllPointsReceived ? 'text' : '')}
      >
        <ButtonLink text="Как собрать заказ?" handleClick={openModal} />
      </PointsInfo>
      <Orders
        setStep={setStep}
        setIdPack={setIdPack}
        isViewModal={isViewModal}
        currentList={currentList}
        setCurrentList={setCurrentList}
        list={list}
        isAllPointsReceived={isAllPointsReceived}
        firstList={firstList}
        secondList={secondList}
        thirdList={thirdList}
        setModal={setModal}
        firstPlay={firstPlay}
      />
    </Layout>
  ) : null;
};

export default Step1;
